// extracted by mini-css-extract-plugin
export default {"heading":"uj-z","list":"vj-z"};